(function() {
    'use strict';

    angular.module('allegro').controller(
        'AllegroConfigurationUpdateController', AllegroConfigurationUpdateController);

    AllegroConfigurationUpdateController.$inject = [
        '$state',
        'notificationSrvc',
        'errorNotificationSrvc',
        'allegroConfigDataSrvc',
        'allegroConfigMessagesConst'
    ];

    function AllegroConfigurationUpdateController(
        $state, notificationSrvc, errorNotificationSrvc, allegroConfigDataSrvc, allegroConfigMessagesConst
    ) {
        var self = this;
        self.loading = true;

        self.serverErrors = {
            client_id: [],
            client_secret: [],
            base_url: [],
            base_api_url: [],
            non_field_errors: []
        };

        self.configurationData = {
            pk: null,
            client_id: '',
            client_secret: '',
            base_url: '',
            base_api_url: '',
        };

        self.getConfiguration = getConfiguration;
        self.updateConfiguration = updateConfiguration;
        self.cleanErrors = cleanErrors;

        active()
        function active(){
            getConfiguration();
        }

        function getConfiguration(){
            return allegroConfigDataSrvc.get({pk: $state.params.pk}).$promise.then(
                function (response) {
                    self.configurationData = response;
                    self.loading = false;
                    return response;
                }
            );
        }

        function updateConfiguration() {
            allegroConfigDataSrvc.update({pk: self.configurationData.pk}, self.configurationData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", allegroConfigMessagesConst.update);
                    $state.go('layout.allegro-configurations.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
